/**
 * Pure formatting helpers for the Monthly files section (REPORTS/reports-archive
 * FE-2a, kept by BUSY-VOUCHER R3). No React, no api calls. The API stays
 * UI-agnostic (raw `size_bytes` bytes, raw `uploaded_at` ISO instant); ALL
 * formatting happens here. (The old per-kind helpers — not-available copy,
 * distinct periods, find-by-kind — went with the old kinds, OR-14.)
 */

const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

const MONTH_ABBR = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];

/** "2026-08" -> "August 2026". */
export function formatPeriodLabel(period) {
  const [year, month] = period.split('-');
  return `${MONTH_NAMES[Number(month) - 1]} ${year}`;
}

/**
 * Raw bytes -> "812 KB" | "1.4 MB" (owner R-1 locked those literal forms —
 * KB with 0 decimals, MB with 1). Deliberately NOT `fileEncoding.js`'s
 * `formatFileSize` (2-dp + "Bytes", a shared file, wrong copy for this row).
 */
export function formatArchiveSize(bytes) {
  const MB = 1024 * 1024;
  if (bytes >= MB) return `${(bytes / MB).toFixed(1)} MB`;
  return `${Math.round(bytes / 1024)} KB`;
}

/**
 * Raw UTC ISO instant -> "3 Sep 2026", rendered in IST with NO clock time
 * (R-7 — "Added" wording lives in the component, this just formats the
 * date). Built from an `en-CA` (`YYYY-MM-DD`) IST-zoned read + our own
 * 3-letter abbreviation table — ICU's `en-GB` short-month formatting
 * renders September as "Sept" (4 letters), which would break the locked
 * `3 Sep 2026` shape.
 */
export function formatAddedDate(iso) {
  const [year, month, day] = new Date(iso)
    .toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' })
    .split('-');
  return `${Number(day)} ${MONTH_ABBR[Number(month) - 1]} ${year}`;
}
